(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1826],{

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ Head; },
/* harmony export */   "Nk": function() { return /* binding */ BodyMask; }
/* harmony export */ });
/* unused harmony export Body */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Item = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Item", componentId: "sc-1lvw3w1-0" })(["width:100%;"]);



var Head = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Head", componentId: "sc-1lvw3w1-1" })(["cursor:pointer;"]);



var Body = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Body", componentId: "sc-1lvw3w1-2" })(["height:0;overflow:hidden;transition:height 0.5s ease-in-out;"]);





var BodyMask = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__BodyMask", componentId: "sc-1lvw3w1-3" })(["padding:0;margin:0;"]);













var Accordion = function Accordion(props) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _props$isOpen = props.isOpen,isOpen = _props$isOpen === void 0 ? false : _props$isOpen;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen),open = _useState[0],setOpen = _useState[1];

  var updateBodyHeight = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var el = ref.current;
    if (el) {
      // for some reason open is not upto date state which causes a close
      setOpen(function (open) {
        var bodyEl = el.querySelector(Body.toString());
        if (!open) {
          // we close
          bodyEl.style.height = '0px';
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              var height = bodyEl.
              querySelector(BodyMask.toString()).
              getBoundingClientRect().height;
              // we open
              bodyEl.style.height = "".concat(height, "px");
            });
          });
        }

        return open;
      });
    }
  }, [ref.current, open]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var el = ref.current;
    if (el) {
      var body = el.querySelector(Body.toString());
      var observer = new MutationObserver(function () {
        updateBodyHeight();
      });

      var config = { childList: true, subtree: true };

      observer.observe(body, config);

      return function () {
        observer.disconnect();
        observer = null;
      };
    }
  }, []);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    updateBodyHeight();
  }, [open]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (open !== isOpen) {
      setOpen(isOpen);
    }
  }, [isOpen]);

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Item, { ref: ref, className: props.className, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Head, {

        onClick: function onClick() {
          if (typeof props.handleOpen === 'function') {
            props.handleOpen();
          } else {var _props$onOpenChange;
            setOpen(!open);
            props === null || props === void 0 ? void 0 : (_props$onOpenChange = props.onOpenChange) === null || _props$onOpenChange === void 0 ? void 0 : _props$onOpenChange.call(props, !open);
          }
        }, children:

        props.head }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { children: /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BodyMask, { children: props.body }) })] }));



};

/* harmony default export */ __webpack_exports__["ZP"] = (Accordion);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 69497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);
/* harmony import */ var _material_ui_core_Switch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9570);
/* harmony import */ var _lib_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62594);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var styles = {
  colorSwitchBase: {
    color: _lib_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].colors.neutrals.white */ .Z.colors.neutrals.white,
    '&$colorChecked': {
      color: _lib_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].colors.neutrals.white */ .Z.colors.neutrals.white,
      '& + $colorBar': {
        backgroundColor: _lib_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].colors.neutrals.white */ .Z.colors.neutrals.white,
        opacity: 1 },

      '& + $track': {
        backgroundColor: _lib_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].colors.primary["blue-2"] */ .Z.colors.primary["blue-2"],
        opacity: 1 } } },



  colorBar: {},
  track: {},
  colorChecked: {} };


var Switch = function Switch(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_material_ui_core_Switch__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      name: props.name,
      checked: props.value,
      value: props.value.toString(),
      onChange: props.onChange,
      onBlur: props.onBlur,
      classes: {
        root: props.classes.root,
        track: props.classes.track,
        switchBase: props.classes.colorSwitchBase,
        checked: props.classes.colorChecked },

      id: props.id }));};



/* harmony default export */ __webpack_exports__["Z"] = ((0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles)(Switch));

/***/ }),

/***/ 36426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94007);
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25077);
/* harmony import */ var _Switch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69497);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/**
 * Is using components, should go to organisms
 */





var SwitchLabel = function SwitchLabel(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, { justifyContent: "space-between", alignItems: "center", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Label__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { htmlFor: props.label, children: props.label }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Switch__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        name: props.name,
        id: props.label,
        value: props.value,
        onChange: props.onChange,
        onBlur: props.onBlur })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (SwitchLabel);

/***/ }),

/***/ 2570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}
// import './slick.css';

var settings = {
  dots: false,
  infinite: false,
  speed: 300,
  centerMode: false,
  variableWidth: true,
  arrows: false,
  slidesToShow: 1,
  swipeToSlide: true,
  adaptiveHeight: true,
  initialSlide: 0 };


var Slick = function Slick(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread(_objectSpread({ className: props.className }, settings), {}, { children:
      props.children })));


};

/* harmony default export */ __webpack_exports__["Z"] = (Slick);

/***/ }),

/***/ 53739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _genre_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var react_esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js + 1 modules
var use_deep_compare_effect_esm = __webpack_require__(87620);
// EXTERNAL MODULE: ./components/Divider.js
var Divider = __webpack_require__(48740);
// EXTERNAL MODULE: ./components/Grid.js
var Grid = __webpack_require__(58941);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var layout_Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/MetaTags.tsx
var MetaTags = __webpack_require__(9128);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(96594);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/FetchSuggestions.ts
var _templateObject;function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var GET_SUGGESTIONS = (0,lib/* default */.ZP)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query searchSuggestions($query: String!) {\n    searchSuggestions(query: $query)\n  }\n"])));





var FetchSuggestions = function FetchSuggestions(props) {
  var mounted = (0,react.useRef)(false);
  var client = (0,useApolloClient/* useApolloClient */.x)();
  var _useState = (0,react.useState)({
    loading: false,
    error: null,
    suggestions: [] }),state = _useState[0],setstate = _useState[1];


  var reset = function reset() {
    setstate({
      loading: false,
      error: null,
      suggestions: [] });

  };

  var setSearchTerm = debounce_default()(function (searchTerm) {
    if (searchTerm === '') {
      reset();
      return;
    }

    setstate(_objectSpread(_objectSpread({}, state), {}, { loading: true }));

    client.
    query({ query: GET_SUGGESTIONS, variables: { query: searchTerm } }).
    then(function (_ref) {var suggestions = _ref.data.searchSuggestions;
      if (mounted.current) {
        props.onLoaded();
        setstate(_objectSpread(_objectSpread({}, state), {}, { loading: false, suggestions: suggestions }));
      }
    })["catch"](
    function () {
      if (mounted.current) {
        props.onLoaded();
        setstate(_objectSpread(_objectSpread({}, state), {}, { loading: false, error: 'ERROOOR' }));
      }
    });
  }, 500);

  var fetch = function fetch() {
    if (mounted.current) {
      setSearchTerm(props.searchValue);
    }
  };

  function prepareFetch() {
    reset();
  }

  (0,react.useEffect)(function () {
    mounted.current = true;

    return function () {
      mounted.current = false;
    };
  }, []);

  (0,react.useEffect)(function () {
    prepareFetch();
    fetch();
  }, [props.searchValue]);

  return props.render(state);
};

/* harmony default export */ var header_FetchSuggestions = (FetchSuggestions);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./ecosystems/navigations/header/DownshiftInput.js
function DownshiftInput_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function DownshiftInput_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? DownshiftInput_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DownshiftInput_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}






// const EmptyState = styled.div`
//   display: block;
//   padding: 15px 10px;
//   cursor: pointer;
//   font-size: 16px;
//   text-align: left;
//   .highlight {
//     font-weight: bold;
//     color: black;
//   }
// `;

function renderSuggestion(_ref)





{var suggestion = _ref.suggestion,index = _ref.index,itemProps = _ref.itemProps,highlightedIndex = _ref.highlightedIndex,selectedItem = _ref.selectedItem;
  var isHighlighted = highlightedIndex === index;
  var isSelected = (selectedItem || '').indexOf(suggestion) > -1;

  return /*#__PURE__*/(
    (0,react.createElement)(MenuItem/* default */.Z, DownshiftInput_objectSpread(DownshiftInput_objectSpread({},
    itemProps), {}, {
      key: "suggestion-item-".concat(index),
      selected: isHighlighted,
      component: "div",
      style: {
        fontWeight: isSelected ? 500 : 400,
        padding: '20px 10px',
        fontSize: '16px',
        fontFamily: 'Libre Franklin' } }),


    suggestion));


}

var styles = function styles(theme) {return {
    root: {
      flexGrow: 1 },

    container: {
      flexGrow: 1,
      position: 'relative' },

    paper: {
      top: '100%',
      position: 'absolute',
      zIndex: 10,
      left: 0,
      right: 0,
      fontFamily: '"Libre Franklin", sans-serif' },

    chip: {
      margin: "".concat(theme.spacing(1 / 2), "px ").concat(theme.spacing(1 / 4), "px") },

    inputRoot: {
      flexWrap: 'wrap' } };};



var DownshiftInput_DownshiftInput = function DownshiftInput(props) {
  var handleSelect = function handleSelect(selectedItem) {
    props.selectSuggestions({ selectedItem: selectedItem });
  };

  var classes = props.classes,defaultInputValue = props.defaultInputValue;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(downshift_esm/* default */.Z, {
      onSelect: handleSelect,
      defaultInputValue: defaultInputValue,
      id: "autocomplete",
      labelId: "autocomplete-label",
      inputId: "autocomplete-input",
      menuId: "autocomplete-menu",
      onInputValueChange: props.onInputValueChange,
      stateReducer: function stateReducer(state, changes) {
        if (
        changes.type === downshift_esm/* default.stateChangeTypes.mouseUp */.Z.stateChangeTypes.mouseUp ||
        changes.type === downshift_esm/* default.stateChangeTypes.blurInput */.Z.stateChangeTypes.blurInput)
        {
          return DownshiftInput_objectSpread(DownshiftInput_objectSpread({},
          changes), {}, {
            inputValue: state.inputValue });

        }
        return changes;
      }, children:

      function children(_ref2) {var
        getInputProps = _ref2.getInputProps,
        getItemProps = _ref2.getItemProps,
        isOpen = _ref2.isOpen,
        inputValue = _ref2.inputValue,
        selectedItem = _ref2.selectedItem,
        highlightedIndex = _ref2.highlightedIndex,
        clearItems = _ref2.clearItems,
        closeMenu = _ref2.closeMenu,
        setState = _ref2.setState;return /*#__PURE__*/(

          (0,jsx_runtime.jsxs)("div", { className: classes.container, children: [
            props.renderInput({
              classes: classes,
              InputProps: getInputProps({
                placeholder: props.placeholder,
                id: props.id,
                autoComplete: 'off' }),

              closeMenu: closeMenu,
              setState: setState }),

            isOpen ? /*#__PURE__*/
            (0,jsx_runtime.jsx)(header_FetchSuggestions, {
              searchValue: inputValue,
              onLoaded: function onLoaded() {
                clearItems();
              },
              limit: 4,
              render: function render(_ref3) {var loading = _ref3.loading,suggestions = _ref3.suggestions,error = _ref3.error;return /*#__PURE__*/(
                  (0,jsx_runtime.jsx)(Paper/* default */.Z, { className: classes.paper, elevation: 2, square: true, children:
                    !(loading && error && suggestions.length === 0) ?
                    suggestions.map(function (suggestion, index) {return (
                        renderSuggestion({
                          suggestion: suggestion,
                          index: index,
                          itemProps: getItemProps({ item: suggestion }),
                          highlightedIndex: highlightedIndex,
                          selectedItem: selectedItem }));}) :


                    null }));} }) :



            null] }));} }));




};

/* harmony default export */ var header_DownshiftInput = (/*#__PURE__*/react.memo((0,withStyles/* default */.Z)(styles)(DownshiftInput_DownshiftInput)));
// EXTERNAL MODULE: ./components/Icon.tsx
var components_Icon = __webpack_require__(54444);
;// CONCATENATED MODULE: ./components/Search.tsx







var Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "Search__Wrapper", componentId: "sc-qs3fmi-0" })(["position:relative;width:100%;[role='combobox']{position:static !important;}"]);








var Input = styled_components_browser_esm["default"].input.withConfig({ displayName: "Search__Input", componentId: "sc-qs3fmi-1" })(["margin:0;width:100%;height:100%;padding:21px 0px;border-radius:5px;background-color:#ffffff;border:solid 1px #eaeaea;text-indent:45px;font-weight:300;color:#242424;font-size:14px;transition:200ms ease-in border;&:hover{cursor:text;}&:focus{border:solid 1px ", ";outline:none;box-shadow:none;}@media (max-width:", "){font-size:16px;}"],


















function (_ref) {var theme = _ref.theme;return theme.colors.primary['blue-2'];},




function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var LeftIconWrapper = styled_components_browser_esm["default"].span.withConfig({ displayName: "Search__LeftIconWrapper", componentId: "sc-qs3fmi-2" })(["position:absolute;left:25px;top:50%;transform:translate(-50%,-50%);z-index:1;"]);







var ResetButton = styled_components_browser_esm["default"].button.withConfig({ displayName: "Search__ResetButton", componentId: "sc-qs3fmi-3" })(["position:absolute;top:50%;right:0;border:none;padding:20px;background:none;transform:translate(-50%,-50%);cursor:pointer;z-index:1;"]);











var Layout = function Layout(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Wrapper, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(LeftIconWrapper, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(components_Icon/* default */.Z, { name: "ygb-icon-searchb", fontSize: "15px", color: "black" }) }),

      props.input] }));


};






var SearchBarWithDownShift = /*#__PURE__*/(/* unused pure expression or super */ null && (React.memo(
function (props) {
  var handleOnSubmit = function handleOnSubmit(newValue) {
    props.onInputChange(newValue);
  };

  var resetInput = function resetInput(InputProps) {
    InputProps.onChange({ target: { value: '' } });
    handleOnSubmit('');
  };
  return /*#__PURE__*/(
    _jsx(Layout, {
      input: /*#__PURE__*/
      _jsx(DownshiftInput, {
        placeholder: /*#__PURE__*/_jsx(Trans, { id: "metadata.search", message: 'Search...' }),
        defaultInputValue:
        props.defaultInputValue ? props.defaultInputValue : '',

        selectSuggestions: function selectSuggestions(_ref2) {var selectedItem = _ref2.selectedItem;
          props.onInputChange(selectedItem);
        },
        renderInput: function renderInput(_ref3) {var InputProps = _ref3.InputProps;
          return /*#__PURE__*/(
            _jsxs(React.Fragment, { children: [/*#__PURE__*/
              _jsx("form", {
                onSubmit: function onSubmit(event) {
                  event.preventDefault();
                  handleOnSubmit(InputProps.value);
                }, children: /*#__PURE__*/

                _jsx(Input, {
                  type: "text",
                  placeholder: /*i18n*/i18n._("metadata.search"),
                  autoComplete: InputProps.autoComplete,
                  value: InputProps.value,
                  onChange: InputProps.onChange,
                  onKeyDown: InputProps.onKeyDown,
                  onBlur: InputProps.onBlur }) }),



              InputProps.value === '' ? null : /*#__PURE__*/
              _jsx(ResetButton, { children: /*#__PURE__*/
                _jsx(Icon, {
                  name: "ygb-icon-close",
                  fontSize: "10px",
                  color: "black",
                  onClick: function onClick() {
                    resetInput(InputProps);
                  } }) })] }));





        } }) }));




})));


var SearchBar = function SearchBar(props) {
  var handleOnSubmit = function handleOnSubmit(value) {
    props.onInputChange(value);
  };

  var handleClickClear = function handleClickClear(setState) {
    setState({ inputValue: '' });
    props.onInputChange('');
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Layout, {
      input: /*#__PURE__*/
      (0,jsx_runtime.jsx)(header_DownshiftInput, {
        placeholder: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "metadata.search", message: 'Search...' }),
        defaultInputValue:
        props.defaultInputValue ? props.defaultInputValue : '',

        selectSuggestions: function selectSuggestions(_ref4) {var selectedItem = _ref4.selectedItem;
          props.onInputChange(selectedItem);
        },
        onInputValueChange: handleOnSubmit,
        renderInput: function renderInput(_ref5) {var InputProps = _ref5.InputProps,closeMenu = _ref5.closeMenu,setState = _ref5.setState;
          return /*#__PURE__*/(
            (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)("form", {
                onSubmit: function onSubmit(event) {
                  event.preventDefault();
                  closeMenu();
                  handleOnSubmit(InputProps.value);
                }, children: /*#__PURE__*/

                (0,jsx_runtime.jsx)(Input, {
                  type: "text",
                  placeholder: /*i18n*/esm/* i18n._ */.ag._("metadata.search"),
                  autoComplete: InputProps.autoComplete,
                  value: InputProps.value,
                  onChange: InputProps.onChange,
                  onKeyDown: InputProps.onKeyDown,
                  onBlur: InputProps.onBlur }) }),



              InputProps.value !== '' && /*#__PURE__*/
              (0,jsx_runtime.jsx)(ResetButton, {
                onClick: function onClick() {
                  handleClickClear(setState);
                }, children: /*#__PURE__*/


                (0,jsx_runtime.jsx)(components_Icon/* default */.Z, { name: "ygb-icon-close", fontSize: "10px", color: "black" }) })] }));




        } }) }));




};

/* harmony default export */ var Search = (/*#__PURE__*/react.memo(SearchBar));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/form/Label.js
var Label = __webpack_require__(25077);
// EXTERNAL MODULE: ./components/form/Select.tsx
var Select = __webpack_require__(76611);
// EXTERNAL MODULE: ./components/CSSGrid.tsx
var CSSGrid = __webpack_require__(68722);
// EXTERNAL MODULE: ./components/LoadMoreSection.js
var LoadMoreSection = __webpack_require__(47442);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/EmptyResults.tsx
var EmptyResults = __webpack_require__(87977);
;// CONCATENATED MODULE: ./ecosystems/EmptyResultsGenre.js





var EmptyResultsGenre = function EmptyResultsGenre(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(EmptyResults/* default */.Z, {

      title: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
          id: "videos_genres.count",
          message: '{count} hits',
          values: { count: 0 } }),
        ' ',
        props.keyword && /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
          id: "videos_genres.keyword",
          message: 'for keyword "{keyword}"',
          values: { keyword: props.keyword } })] }),




      icon: "ygb-icon-searchb",
      action: /*#__PURE__*/
      (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children:
        !props.emptyTerms ? /*#__PURE__*/
        (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
            id: "emptyresults.try_adjusting_or",
            message: "Try adjusting your search criteria for more results, or" }),
          ' ', /*#__PURE__*/
          (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "link", onClick: props.clearAll, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "emptyresults.click_here", message: "click here" }) }),
          ' ', /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
            id: "emptyresults.to_clear_filters",
            message: "to clear all filters" })] }) : /*#__PURE__*/



        (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, {
            flexDirection: "column",
            alignItems: "center",
            px: ['10px', '10px', '200px'], children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "30px", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "emptyresults.empty_filter",
                message: "Please adjust your tags above and edit your video <0>settings</0> like languages, level, etc... to get the results you are looking for",
                components: [/*#__PURE__*/
                (0,jsx_runtime.jsx)(buttons/* default */.ZP, {

                  appearance: "link",
                  onClick: props.openSettingModal }, "settings")] }) }) }) }) }) }));











};

/* harmony default export */ var ecosystems_EmptyResultsGenre = (EmptyResultsGenre);
// EXTERNAL MODULE: ./lib/apollo/index.tsx + 1 modules
var apollo = __webpack_require__(15049);
// EXTERNAL MODULE: ./organisms/cards/VideoCard.tsx
var VideoCard = __webpack_require__(85551);
// EXTERNAL MODULE: ./skeletons/VideosGenresVideosSkeleton.js
var VideosGenresVideosSkeleton = __webpack_require__(34218);
// EXTERNAL MODULE: ./lib/analytics/manager.ts + 4 modules
var manager = __webpack_require__(88224);
// EXTERNAL MODULE: ./components/texts.tsx
var texts = __webpack_require__(45945);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./organisms/cards/ProgramListingCard/index.tsx
var ProgramListingCard = __webpack_require__(80226);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./lib/hooks/useFlags.tsx
var hooks_useFlags = __webpack_require__(55932);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./organisms/cards/OfferCard.tsx








var Anchor = (0,styled_components_browser_esm["default"])((link_default())).withConfig({ displayName: "OfferCard__Anchor", componentId: "sc-heml3s-0" })(["display:flex;color:inherit;text-decoration:none;&:nth-of-type(n + 2){display:none;}& ~ .VideoGenresList--VideoCard:nth-of-type(12n):last-of-type{display:none;}"]);













var Text = styled_components_browser_esm["default"].span.withConfig({ displayName: "OfferCard__Text", componentId: "sc-heml3s-1" })(["display:flex;flex-direction:column;justify-content:center;font-size:", "px;font-weight:", ";margin:0 0 10px;"],



function (_ref) {var fontSize = _ref.fontSize;return fontSize || 18;},
function (_ref2) {var fontWeight = _ref2.fontWeight;return fontWeight || 'normal';});



var Body = styled_components_browser_esm["default"].div.withConfig({ displayName: "OfferCard__Body", componentId: "sc-heml3s-2" })(["flex:1;display:flex;flex-direction:column;justify-content:center;color:white;text-align:center;"]);









var Image = styled_components_browser_esm["default"].img.withConfig({ displayName: "OfferCard__Image", componentId: "sc-heml3s-3" })(["width:100%;min-height:100%;object-fit:cover;"]);





var Footer = (0,styled_components_browser_esm["default"])(ProgramListingCard/* ProgramCardFooter */.p7).withConfig({ displayName: "OfferCard__Footer", componentId: "sc-heml3s-4" })(["justify-content:center;color:#fff;border-color:rgba(6,129,184,1);background-color:", ";svg{margin-left:10px;path{fill:white;}}p{font-size:14px;font-weight:600;svg{display:none;}}"],



function (_ref3) {var theme = _ref3.theme;return theme.colors.secondary.blue;});



















var OfferCard = function OfferCard(_ref4) {var _ref4$className = _ref4.className,className = _ref4$className === void 0 ? '' : _ref4$className;
  var _useFlags = useFlags(),_useFlags2 = _slicedToArray(_useFlags, 1),flags = _useFlags2[0];
  // const [currentUser] = useContext(UserContext);
  var locale = useContext(LanguageContext);

  if (
  !flags.yearly_campaign_banners
  //   !['se', 'no'].includes(lang) ||
  //   // user not loaded yet
  //   currentUser === undefined ||
  //   // user doesnt have trial premium
  //   (currentUser?.subscription?.status === SubscriptionStatus['Active'] &&
  //     ['monthly', 'quarterly', 'yearly'].includes(
  //       currentUser?.subscription?.currentSubscriptionPlan?.planType
  //     )) ||
  //   // has wellness
  //   currentUser?.hasWellness
  ) {
    return null;
  }

  var lang = ['en', 'fi'].includes(locale) ? 'en' : 'se';

  var href = "/".concat(lang, "/yearly?ref=library_square_banner");
  return /*#__PURE__*/(
    _jsx(Anchor, { className: className, href: href, children: /*#__PURE__*/
      _jsx(Card, { children: /*#__PURE__*/
        _jsx(Body, { children: /*#__PURE__*/








          _jsx(Image, {
            src:
            lang === 'en' ?
            '/static/yearly/ENg_Web_1_1.jpg' :
            '/static/yearly/Web_1_1.jpg' }) }) }) }));









};

/* harmony default export */ var cards_OfferCard = ((/* unused pure expression or super */ null && (OfferCard)));
;// CONCATENATED MODULE: ./organisms/cards/YearlyOfferCard.tsx








var YearlyOfferCard_Body = styled_components_browser_esm["default"].div.withConfig({ displayName: "YearlyOfferCard__Body", componentId: "sc-12slw8p-0" })(["flex:1;display:flex;flex-direction:column;justify-content:center;color:white;text-align:center;"]);









var YearlyOfferCard_Image = styled_components_browser_esm["default"].img.withConfig({ displayName: "YearlyOfferCard__Image", componentId: "sc-12slw8p-1" })(["width:100%;min-height:100%;object-fit:cover;"]);





var YearlyOfferCard = function YearlyOfferCard(_ref) {var _ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className;
  var _useFlags = (0,hooks_useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  if (!flags.yearly_campaign_banners) {
    return null;
  }

  var img = ['en', 'fi'].includes(lang) ?
  '/static/yearly/EN_Banner_Startpage_Square_b.jpg' :
  '/static/yearly/SE_Banner_Startpage_Square_b.jpg';

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Anchor, { href: "/".concat(lang, "/yearly"), className: className, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(ProgramListingCard/* Card */.Zb, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(YearlyOfferCard_Body, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(YearlyOfferCard_Image, { src: img }) }) }) }));




};
;// CONCATENATED MODULE: ./organisms/cards/SpringBoostCard.tsx








var SpringBoostCard_Body = styled_components_browser_esm["default"].div.withConfig({ displayName: "SpringBoostCard__Body", componentId: "sc-1yajnrj-0" })(["flex:1;display:flex;flex-direction:column;justify-content:center;color:white;text-align:center;"]);









var SpringBoostCard_Image = styled_components_browser_esm["default"].img.withConfig({ displayName: "SpringBoostCard__Image", componentId: "sc-1yajnrj-1" })(["width:100%;min-height:100%;object-fit:cover;"]);





var SpringBoostCard = function SpringBoostCard(_ref) {var _ref$className = _ref.className,className = _ref$className === void 0 ? '' : _ref$className;
  var _useFlags = (0,hooks_useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var lang = (0,react.useContext)(languageContext/* default */.Z);

  if (
  !flags.yearly_campaign_banners &&
  flags !== null && flags !== void 0 && flags.yearly_campaign &&
  ['se', 'no'].includes(lang))
  {
    return /*#__PURE__*/(
      (0,jsx_runtime.jsx)(Anchor, { href: "/".concat(lang, "/c/yogobe/b/spring-boost"), className: className, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(ProgramListingCard/* Card */.Zb, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(SpringBoostCard_Body, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(SpringBoostCard_Image, { src: "/static/banner_springboost_startpage_square.jpg" }) }) }) }));




  } else {
    return null;
  }
};
;// CONCATENATED MODULE: ./ecosystems/VideoGenresList.tsx
function VideoGenresList_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function VideoGenresList_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? VideoGenresList_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VideoGenresList_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




















var VideoGenresList = function VideoGenresList(_ref)






{var _router$query, _videos$data, _videos$data$map;var query = _ref.query,genre = _ref.genre,taxonomies = _ref.taxonomies,selectedTerms = _ref.selectedTerms,clearAll = _ref.clearAll,renderTeachersSection = _ref.renderTeachersSection;
  var router = (0,next_router.useRouter)();
  var _useState = (0,react.useState)('published_descending'),orderBy = _useState[0],setOrderBy = _useState[1];
  var _useState2 = (0,react.useState)(false),fetchingMore = _useState2[0],setFetchingMore = _useState2[1];
  var _useQuery = (0,useQuery/* useQuery */.a)(
  apollo/* GET_VIDEO_SETTINGS */.ji),preferences = _useQuery.data,loadingPreferences = _useQuery.loading;


  var variables = VideoGenresList_objectSpread({
    taxonomies: Object.keys(selectedTerms).map(function (key) {return {
        taxonomy: key,
        values: selectedTerms[key] };}),

    perPage: 12,
    query: query,
    genre: genre === 'all' ? '' : genre,
    useLocale: false,
    orderBy: orderBy },
  Object.assign({}, preferences === null || preferences === void 0 ? void 0 : preferences.videoSettings));


  var page = parseInt((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.page) || 1;

  var getVideosResponse = (0,generated/* useVideosQuery */.Eov)({
    variables: Object.assign(variables, preferences === null || preferences === void 0 ? void 0 : preferences.videoSettings, { page: page }) });


  (0,use_deep_compare_effect_esm/* default */.ZP)(function () {
    if (preferences !== null && preferences !== void 0 && preferences.videoSettings) {
      (0,manager/* default */.Z)().sendSearchEvent({
        taxonomies: variables.taxonomies,
        query: variables.query,
        genre: variables.genre });

    }
  }, [preferences, variables]);

  var openSettingModal = function openSettingModal() {
    (0,apollo/* videoSettingsModalOpenVar */.cB)(true);
  };

  if (loadingPreferences) return /*#__PURE__*/(0,jsx_runtime.jsx)(VideosGenresVideosSkeleton/* default */.Z, {});

  var data = getVideosResponse.data,loading = getVideosResponse.loading;
  if (loading && !data) return /*#__PURE__*/(0,jsx_runtime.jsx)(VideosGenresVideosSkeleton/* default */.Z, {});

  var videos = data === null || data === void 0 ? void 0 : data.videos;

  if ((videos === null || videos === void 0 ? void 0 : videos.totalCount) === 0) {
    return /*#__PURE__*/(
      (0,jsx_runtime.jsx)(ecosystems_EmptyResultsGenre, {
        keyword: query,
        emptyTerms: !selectedTerms.length,
        clearAll: clearAll
        //TODO: FIX THIS
        , openSettingModal: openSettingModal }));


  }

  var selectedTagsText;
  if (Object.keys(selectedTerms || {}).length > 0) {
    var flattenTags = taxonomies.
    reduce(function (acc, taxonomy) {
      if (
      selectedTerms.hasOwnProperty(taxonomy.slug) &&
      // we exclude duration from the list
      taxonomy.slug !== 'durations')
      {
        acc.push(
        taxonomy.terms.reduce(function (acc, term) {
          if (selectedTerms[taxonomy.slug].includes(term.slug)) {
            acc.push(term.name);
          }
          return acc;
        }, []));

      }

      return acc;
    }, []).
    flat();

    var selectedTags = [];
    if (flattenTags.length > 4) {
      selectedTags = flattenTags.slice(0, 4);
    } else {
      selectedTags = (0,toConsumableArray/* default */.Z)(flattenTags);
    }

    selectedTagsText = selectedTags.join(', ');
    if (flattenTags.length > 4) {
      selectedTagsText = /*#__PURE__*/
      (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
        selectedTagsText, ' ', /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
          id: "metadata.more_items",
          values: { number: flattenTags.length - 4 } })] });



    }
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(layout_Grid/* Flex */.kC, { justifyContent: "space-between", alignItems: "center", mb: "20px", children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { children: /*#__PURE__*/
          (0,jsx_runtime.jsxs)(_StyledLabel, { children: [/*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
              id: "videos_genres.count",
              message: '{count} hits',
              values: { count: videos === null || videos === void 0 ? void 0 : videos.totalCount } }),

            query && /*#__PURE__*/
            (0,jsx_runtime.jsxs)(react.Fragment, { children: [
              ' ', /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "videos_genres.keyword",
                message: 'for keyword "{keyword}"',
                values: { keyword: query } })] }),



            selectedTagsText ? /*#__PURE__*/
            (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [
              query ? ',' : ' for', " ", selectedTagsText] }) :

            null] }) }), /*#__PURE__*/


        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { as: layout_Grid/* ShowInLargeUp */.tf, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { mx: "-10px", alignItems: "center", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { px: "10px", children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(Select/* default */.Z, {
                  onChange: function onChange(event) {var _event$target;
                    setOrderBy(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
                  },
                  selectedValue: orderBy,
                  options: [
                  {
                    value: 'published_descending',
                    name: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                      id: "sortby.published_at",
                      message: "Published At" }) },



                  {
                    value: 'duration_ascending',
                    name: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "sortby.time", message: "Time" }) }] }) }) }) }) })] }), /*#__PURE__*/








      (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { as: layout_Grid/* ShowInMediumDown */.EO, alignItems: "end", mb: 15, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Select/* default */.Z, {
            onChange: function onChange(event) {var _event$target2;
              setOrderBy(event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value);
            },
            selectedValue: orderBy,
            options: [
            {
              value: 'published_descending',
              name: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "sortby.published_at", message: "Published At" }) },

            {
              value: 'duration_ascending',
              name: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "sortby.time", message: "Time" }) }] }) }) }), /*#__PURE__*/





      (0,jsx_runtime.jsxs)(CSSGrid/* default */.Z, { cardWidth: 300, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(YearlyOfferCard, {}), /*#__PURE__*/
        (0,jsx_runtime.jsx)(SpringBoostCard, {}),
        videos === null || videos === void 0 ? void 0 : (_videos$data = videos.data) === null || _videos$data === void 0 ? void 0 : (_videos$data$map = _videos$data.map) === null || _videos$data$map === void 0 ? void 0 : _videos$data$map.call(_videos$data, function (video) {var _video$content, _video$assets, _video$taxonomies, _video$taxonomies2, _video$taxonomies2$ge, _video$taxonomies3, _video$taxonomies3$ge, _video$taxonomies4;
          return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(VideoCard/* default */.Z, {

              className: "VideoGenresList--VideoCard",
              video: {
                id: video.id,
                identifier: video.identifier,
                kind: video.kind,
                title: video.content.title,
                cursorAt: video.cursorAt,
                description: (_video$content = video.content) === null || _video$content === void 0 ? void 0 : _video$content.shortDescription,
                thumbnailUrl: (_video$assets = video.assets) === null || _video$assets === void 0 ? void 0 : _video$assets.thumbnailUrl,
                flavor: video !== null && video !== void 0 && (_video$taxonomies = video.taxonomies) !== null && _video$taxonomies !== void 0 && _video$taxonomies.flavor ?
                video.taxonomies.flavor.name :
                '',
                publishedAt: video.meta.publishedAt,
                duration: video.meta.minutes,
                genreName: (_video$taxonomies2 = video.taxonomies) !== null && _video$taxonomies2 !== void 0 && (_video$taxonomies2$ge = _video$taxonomies2.genre) !== null && _video$taxonomies2$ge !== void 0 && _video$taxonomies2$ge.name ?
                video.taxonomies.genre.name :
                '',
                genreSlug: (_video$taxonomies3 = video.taxonomies) !== null && _video$taxonomies3 !== void 0 && (_video$taxonomies3$ge = _video$taxonomies3.genre) !== null && _video$taxonomies3$ge !== void 0 && _video$taxonomies3$ge.slug ?
                video.taxonomies.genre.slug :
                '',
                instructors: ((_video$taxonomies4 = video.taxonomies) === null || _video$taxonomies4 === void 0 ? void 0 : _video$taxonomies4.instructors) || [],
                primaryStyle: video.primaryStyle } }, video.id));




        })] }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(LoadMoreSection/* default */.Z, {
        data: videos,
        loading: fetchingMore,
        onLoadMoreClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                  setFetchingMore(true);_context.next = 3;return (
                    getVideosResponse.fetchMore({
                      variables: Object.assign(variables, preferences === null || preferences === void 0 ? void 0 : preferences.videoSettings, {
                        page: videos.page + 1 }) }));case 3:


                  router.push(
                  {
                    pathname: router.pathname,
                    query: VideoGenresList_objectSpread(VideoGenresList_objectSpread({}, router.query), {}, { page: videos.page + 1 }) },

                  null,
                  {
                    shallow: true,
                    scroll: false });


                  setFetchingMore(false);case 5:case "end":return _context.stop();}}}, _callee);})) }),



      renderTeachersSection()] }));


};

/* harmony default export */ var ecosystems_VideoGenresList = (VideoGenresList);var _StyledLabel = (0,styled_components_browser_esm["default"])(Label/* default */.Z).withConfig({ displayName: "VideoGenresList___StyledLabel", componentId: "sc-1l9q6tk-0" })(["", ""], texts/* sectionTitleStyle */.d1);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 197 modules
var es = __webpack_require__(87111);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./lib/contexts/deviceContext.js
var deviceContext = __webpack_require__(87811);
// EXTERNAL MODULE: ./components/Accordion.tsx
var Accordion = __webpack_require__(9451);
;// CONCATENATED MODULE: ./components/MenuItem.tsx




var Element = styled_components_browser_esm["default"].div.withConfig({ displayName: "MenuItem__Element", componentId: "sc-1x6sjoa-0" })(["display:inline-flex;margin-right:32px;color:#3c3c3c;font-size:13px;cursor:pointer;transition:color 300ms ease-in,opacity 300ms ease-in;opacity:", ";i{display:inline-flex;align-items:center;transition:transform 300ms ease-out;will-change:transform;transform:rotate(", "deg);}span{margin-right:5px;}&:hover{color:#000;transition:color 300ms ease-in;}"],






function (_ref) {var isSelected = _ref.isSelected;
  return isSelected ? 1 : 0.5;
},






function (_ref2) {var isSelected = _ref2.isSelected;return isSelected ? 180 : 0;});












var MenuItem_MenuItem = function MenuItem(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Element, { isSelected: props.isSelected, onClick: props.onClick, children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)("span", { children: props.children }), /*#__PURE__*/
      (0,jsx_runtime.jsx)(components_Icon/* default */.Z, { fontSize: "7.5px", name: "ygb-icon-chevron-down" })] }));


};

/* harmony default export */ var components_MenuItem = (MenuItem_MenuItem);
;// CONCATENATED MODULE: ./components/Tag.js





var Tag_Element = styled_components_browser_esm["default"].button.withConfig({ displayName: "Tag__Element", componentId: "sc-ggr7bm-0" })(["display:inline-flex;align-items:center;color:", ";font-size:12px;font-weight:300;border-radius:3px;padding:5px;border:", ";outline:none;background-color:", ";transition:color 300ms ease-in,border 200ms ease-in,background-color 300ms ease-out;cursor:pointer;&:hover{border:", ";}i{margin-left:5px;}"],


function (_ref) {var isSelected = _ref.isSelected;return isSelected ? '#fff' : '#6b6f81';},




function (_ref2) {var isSelected = _ref2.isSelected;return isSelected ? 'none' : '1px solid #eeeeee';},

function (_ref3) {var isSelected = _ref3.isSelected;return isSelected ? '#88bfbd' : '#fff';},





function (props) {return props.isSelected ? 'none' : '1px solid #c3c3c3';});







var Tag = function Tag(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(Tag_Element, {
      onClick: props.onClick,
      isSelected: props.isSelected,
      important: props.important,
      "data-taxonomy": props.taxonomy,
      "data-term": props.term, children: [/*#__PURE__*/

      (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { children: props.children }),
      props.isSelected ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_Icon/* default */.Z, { name: "ygb-icon-close", fontSize: "8px" }) : null] }));


};

/* harmony default export */ var components_Tag = (Tag);
// EXTERNAL MODULE: ./components/layout/Span.js
var Span = __webpack_require__(88865);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
;// CONCATENATED MODULE: ./organisms/modals/SearchFiltersModal.js











var ClearButton = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "SearchFiltersModal__ClearButton", componentId: "sc-4yzkzb-0" })(["margin:0 0 0 auto;"]);



var SearchFiltersModal = function SearchFiltersModal(props) {
  var selectedTaxonomy =
  props.taxonomies.find(
  function (taxonomy) {return taxonomy.slug === props.selectedTaxonomySlug;}) ||
  {};
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(base/* Modal */.u_, { open: props.open, handleClose: props.clearAll, children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(base/* Header */.h4, { noCloseButton: true, children: [/*#__PURE__*/
        (0,jsx_runtime.jsxs)(layout_Grid/* Box */.xu, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(components_Icon/* default */.Z, {
            name: "ygb-icon-close",
            fontSize: "13.5px",
            onClick: props.handleClose }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(Span/* default */.Z, { marginLeft: 15, children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Label/* default */.Z, { children: selectedTaxonomy.name }) })] }), /*#__PURE__*/


        (0,jsx_runtime.jsx)(ClearButton, { appearance: "link", onClick: props.clearAll, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "metadata.clear_all", message: 'Clear all' }) })] }), /*#__PURE__*/


      (0,jsx_runtime.jsx)(base/* Body */.uT, { children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(layout_Grid/* Box */.xu, { px: [25, 25, 50], pb: 30, children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "20px", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Label/* default */.Z, { children: selectedTaxonomy.name }) }), /*#__PURE__*/

          (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { flexWrap: "wrap", children:
            selectedTaxonomy.terms &&
            selectedTaxonomy.terms.map(function (term, index) {return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { width: 1 / 2, mb: "10px", children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(components_Tag, {
                    important: term.important,
                    isSelected: term.selected,
                    onClick: function onClick() {return props.handleClickTerm(term);}, children:

                    term.name }) }, index));}) })] }) }), /*#__PURE__*/






      (0,jsx_runtime.jsx)(base/* Footer */.$_, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, { fullWidth: true, onClick: props.handleClose, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "metadata.save", message: "Save" }) }) })] }));




};

/* harmony default export */ var modals_SearchFiltersModal = (SearchFiltersModal);
// EXTERNAL MODULE: ./organisms/Slick.js
var Slick = __webpack_require__(2570);
;// CONCATENATED MODULE: ./ecosystems/VideosGenresFilters.tsx
function VideosGenresFilters_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function VideosGenresFilters_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? VideosGenresFilters_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VideosGenresFilters_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

















var SelectedTerms = styled_components_browser_esm["default"].div.withConfig({ displayName: "VideosGenresFilters__SelectedTerms", componentId: "sc-1v97seu-0" })(["overflow:hidden;"]);



var SelectedTermsComponent = function SelectedTermsComponent(_ref)





{var selectedTerms = _ref.selectedTerms,modifiedTaxonomies = _ref.modifiedTaxonomies,handleSelectTerm = _ref.handleSelectTerm,clearAll = _ref.clearAll,isMobile = _ref.isMobile;
  var _useState = (0,react.useState)([]),selectedTaxs = _useState[0],setSelectedTaxs = _useState[1];
  (0,use_deep_compare_effect_esm/* default */.ZP)(function () {
    var taxonomies = [];
    (modifiedTaxonomies || []).forEach(function (taxonomy) {
      var selectedTaxonomies = taxonomy.terms.filter(function (e) {return e.selected;});
      if (selectedTaxonomies && selectedTaxonomies.length > 0) {
        taxonomies.push(
        selectedTaxonomies.map(function (term) {return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mr: "10px", mb: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(components_Tag, {
                isSelected: true,
                term: term.slug,
                taxonomy: taxonomy.slug,
                onClick: function onClick() {
                  handleSelectTerm(term, taxonomy.slug);
                }, children:

                term.name }) }, term.slug));}));




      }
    });
    setSelectedTaxs(taxonomies);
  }, [selectedTerms, modifiedTaxonomies]);

  if (isMobile && selectedTaxs.length > 0) {
    return /*#__PURE__*/(
      (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: 20, as: Divider/* default */.Z }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "20px", alignItems: "center", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Slick/* default */.Z, { children: selectedTaxs }) })] }));



  }

  if (selectedTaxs.length > 0) {
    return /*#__PURE__*/(
      (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: 20, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Divider/* default */.Z, {}) }), /*#__PURE__*/


        (0,jsx_runtime.jsxs)(layout_Grid/* Flex */.kC, { mb: "10px", alignItems: "start", children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mr: "20px", mb: "10px", onClick: clearAll, flex: "0 0 auto", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Label/* default */.Z, { children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "metadata.clear_all", message: 'Clear all' }) }) }), /*#__PURE__*/


          (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { flex: "1", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { flexWrap: "wrap", id: 'selected_taxonomies', children:
              selectedTaxs }) })] })] }));





  }

  return null;
};

var SearchFilter = function SearchFilter(props) {
  var taxonomies = props.taxonomies,selectedTerms = props.selectedTerms;
  var _useQuery = (0,useQuery/* useQuery */.a)(apollo/* GET_VIDEO_SETTINGS */.ji, { ssr: false }),loading = _useQuery.loading,data = _useQuery.data;
  var _useState2 = (0,react.useState)(false),isModalOpen = _useState2[0],openModal = _useState2[1];
  var _useState3 = (0,react.useState)(null),selectedTaxonomySlug = _useState3[0],setSelectedTaxonomySlug = _useState3[1];
  var _useState4 = (0,react.useState)(taxonomies),modifiedTaxonomies = _useState4[0],modifyTaxonomies = _useState4[1];
  var _useContext = (0,react.useContext)(deviceContext/* default */.Z),isDeviceMobile = _useContext.isDeviceMobile;

  (0,use_deep_compare_effect_esm/* default */.ZP)(function () {
    var newTaxonomies = taxonomies.map(function (_tax) {
      var tax = VideosGenresFilters_objectSpread({}, _tax);
      tax.terms = tax.terms.map(function (_term) {var _selectedTerms$tax$sl;
        var term = VideosGenresFilters_objectSpread({}, _term);
        if ((_selectedTerms$tax$sl = selectedTerms[tax.slug]) !== null && _selectedTerms$tax$sl !== void 0 && _selectedTerms$tax$sl.includes(term.slug)) {
          term.selected = true;
        } else {
          term.selected = false;
        }
        return term;
      });

      return tax;
    });
    modifyTaxonomies(newTaxonomies);
  }, [selectedTerms, taxonomies]);

  var handleSelectTaxonomy = function handleSelectTaxonomy(taxonomy) {
    setSelectedTaxonomySlug(
    selectedTaxonomySlug === taxonomy.slug ? null : taxonomy.slug);

  };

  // NOTE: this should probably be lifted up
  // no need to update object here send it to get it back from the parent
  var handleSelectTerm = function handleSelectTerm(term) {var _terms$taxonomy;var taxonomy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selectedTaxonomySlug;
    // Handle click term here
    var terms = es/* clone */.d9v(selectedTerms);
    if ((_terms$taxonomy = terms[taxonomy]) !== null && _terms$taxonomy !== void 0 && _terms$taxonomy.includes(term.slug)) {
      // Unselect term
      terms[taxonomy].splice(terms[taxonomy].indexOf(term.slug), 1);
      if (terms[taxonomy].length === 0) {
        delete terms[taxonomy];
      }
    } else {
      // Select term
      if (terms[taxonomy]) {
        terms[taxonomy].push(term.slug);
      } else {
        terms[taxonomy] = [term.slug];
      }
    }
    props.onChange(terms);
  };

  var clearAll = function clearAll() {
    props.onChange([]);
  };

  if (loading) {
    return null;
  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(react_media/* default */.Z, { query: { maxWidth: 767 }, defaultMatches: isDeviceMobile, children:
        function children(matches) {return (
            matches ? /*#__PURE__*/
            (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "20px", width: 1, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(Slick/* default */.Z, { children:
                  props.taxonomies.map(function (taxonomy) {return /*#__PURE__*/(
                      (0,jsx_runtime.jsx)(components_MenuItem, {

                        isSelected: selectedTaxonomySlug === taxonomy.slug,
                        onClick: function onClick() {
                          handleSelectTaxonomy(taxonomy);
                          openModal(true);
                        }, children:

                        taxonomy.name }, taxonomy.slug));}) }) }), /*#__PURE__*/




              (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { as: SelectedTerms, mr: -20, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(SelectedTermsComponent, {

                  selectedTerms: selectedTerms,
                  modifiedTaxonomies: modifiedTaxonomies,
                  handleSelectTerm: handleSelectTerm,
                  clearAll: clearAll,

                  isMobile: true }) })] }) : /*#__PURE__*/




            (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
              (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "20px", children: /*#__PURE__*/

                (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { children:
                  props.taxonomies.map(function (taxonomy) {return /*#__PURE__*/(
                      (0,jsx_runtime.jsx)(components_MenuItem, {

                        isSelected: taxonomy.slug === selectedTaxonomySlug,
                        onClick: function onClick() {
                          handleSelectTaxonomy(taxonomy);
                        }, children:

                        taxonomy.name }, taxonomy.slug));}) }) }), /*#__PURE__*/




              (0,jsx_runtime.jsx)(TaxonomiesList, {
                selectedTaxonomySlug: selectedTaxonomySlug,
                modifiedTaxonomies: modifiedTaxonomies,
                onSelectTerm: handleSelectTerm }), /*#__PURE__*/

              (0,jsx_runtime.jsx)(SelectedTermsComponent, {

                selectedTerms: selectedTerms,
                modifiedTaxonomies: modifiedTaxonomies,
                handleSelectTerm: handleSelectTerm,
                clearAll: clearAll,

                isMobile: false })] }));} }), /*#__PURE__*/







      (0,jsx_runtime.jsx)(modals_SearchFiltersModal, {
        taxonomies: modifiedTaxonomies,
        selectedTaxonomySlug: selectedTaxonomySlug,
        open: isModalOpen,
        handleClose: function handleClose() {
          openModal(false);
          setSelectedTaxonomySlug(null);
        },
        handleClickTerm: handleSelectTerm,
        clearAll: clearAll })] }));



};

var TaxonomiesList = function TaxonomiesList(props) {
  var selected =
  props.selectedTaxonomySlug &&
  props.modifiedTaxonomies.find(
  function (taxonomy) {return taxonomy.slug === props.selectedTaxonomySlug;});


  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Accordion/* default */.ZP, {
      isOpen: selected,
      head: "",
      body:
      selected ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { flexWrap: "wrap", children:
        selected.terms.map(function (term) {return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mr: "10px", mb: "10px", children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(components_Tag, {
                important: term.important,
                isSelected: term.selected,
                onClick: function onClick() {
                  props.onSelectTerm(term);
                }, children:

                term.name }) }, term.slug));}) }) :




      null }));



};
/* harmony default export */ var VideosGenresFilters = (SearchFilter);
;// CONCATENATED MODULE: ./lib/hooks/useDebounce.js


// Our hook
function useDebounce(value, delay) {
  // State and setters for debounced value
  var _useState = (0,react.useState)(value),debouncedValue = _useState[0],setDebouncedValue = _useState[1];

  (0,react.useEffect)(
  function () {
    // Set debouncedValue to value (passed in) after the specified delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay);

    // Return a cleanup function that will be called every time ...
    // ... useEffect is re-called. useEffect will only be re-called ...
    // ... if value changes (see the inputs array below).
    // This is how we prevent debouncedValue from changing if value is ...
    // ... changed within the delay period. Timeout gets cleared and restarted.
    // To put it in context, if the user is typing within our app's ...
    // ... search box, we don't want the debouncedValue to update until ...
    // ... they've stopped typing for more than 500ms.
    return function () {
      clearTimeout(handler);
    };
  },
  // Only re-call effect if value changes
  // You could also add the "delay" var to inputs array if you ...
  // ... need to be able to change that dynamically.
  [value]);


  return debouncedValue;
}
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./components/TextWithIcon.js
var TextWithIcon = __webpack_require__(64370);
// EXTERNAL MODULE: ./node_modules/lodash/xor.js
var xor = __webpack_require__(76566);
var xor_default = /*#__PURE__*/__webpack_require__.n(xor);
// EXTERNAL MODULE: ./components/form/checkbox/Checkbox.js + 1 modules
var Checkbox = __webpack_require__(9310);
// EXTERNAL MODULE: ./components/form/SwitchLabel.js
var SwitchLabel = __webpack_require__(36426);
// EXTERNAL MODULE: ./components/typography/Headings.tsx
var Headings = __webpack_require__(94268);
// EXTERNAL MODULE: ./components/typography/Paragraph.js
var Paragraph = __webpack_require__(36225);
;// CONCATENATED MODULE: ./organisms/modals/SettingsModal.js
var SettingsModal_templateObject;

















var TERMS = function TERMS() {
  return [
  {
    value: 'prenatal',
    display_name: /*i18n*/esm/* i18n._ */.ag._("settings_modal.prenatal") },

  {
    value: 'postnatal',
    display_name: /*i18n*/esm/* i18n._ */.ag._("settings_modal.postnatal") },

  {
    value: 'senioryoga',
    display_name: /*i18n*/esm/* i18n._ */.ag._("settings_modal.senior-yoga") },

  {
    value: 'barn-ungdom',
    display_name: /*i18n*/esm/* i18n._ */.ag._("settings_modal.barn-ungdom") },

  {
    value: 'accessible-yoga',
    display_name: /*i18n*/esm/* i18n._ */.ag._("settings_modal.accessible-yoga") },

  {
    value: 'office-yoga',
    display_name: /*i18n*/esm/* i18n._ */.ag._("settings_modal.office-yoga") }];


};

var LANGUAGES = function LANGUAGES() {
  return [
  {
    label: /*i18n*/esm/* i18n._ */.ag._("settings_modal.swedish"),
    slug: 'se',
    icon: 'ic_flag_sweden' },

  {
    label: /*i18n*/esm/* i18n._ */.ag._("settings_modal.norwegian"),
    slug: 'no',
    icon: 'ic_flag_norway' },

  {
    label: /*i18n*/esm/* i18n._ */.ag._("settings_modal.english"),
    slug: 'en',
    icon: 'ic_flag_greatbritain' },

  {
    label: /*i18n*/esm/* i18n._ */.ag._("settings_modal.finnish"),
    slug: 'fi',
    icon: 'ic_flag_finland' }];


};

var H4EXT = (0,styled_components_browser_esm["default"])(Headings.H4).withConfig({ displayName: "SettingsModal__H4EXT", componentId: "sc-hc885c-0" })(["margin:0;"]);



var Img = styled_components_browser_esm["default"].img.withConfig({ displayName: "SettingsModal__Img", componentId: "sc-hc885c-1" })(["display:inline-block;"]);



var SETTINGS_MODAL_QUERY = (0,lib/* default */.ZP)(SettingsModal_templateObject || (SettingsModal_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query isVideoSettingsModalOpen {\n    isVideoSettingsModalOpen @client\n  }\n"])));





var SettingsModal = function SettingsModal(props) {
  var _useQuery = (0,useQuery/* useQuery */.a)(SETTINGS_MODAL_QUERY),loadingModalState = _useQuery.loading,data = _useQuery.data;
  var _ref = data || {},open = _ref.isVideoSettingsModalOpen;

  var _useState = (0,react.useState)([]),excludeTerms = _useState[0],setExcludeTerms = _useState[1];
  var _useState2 = (0,react.useState)([]),contentLanguages = _useState2[0],setContentLanguages = _useState2[1];
  var _useState3 = (0,react.useState)([]),videoLevels = _useState3[0],setVideoLevels = _useState3[1];

  react.useEffect(function () {
    var videoSettings = props.videoSettings;
    setExcludeTerms(videoSettings.excludeTerms);
    setContentLanguages(videoSettings.contentLanguages);
    setVideoLevels(videoSettings.videoLevels);
  }, [props.videoSettings]);

  if (loadingModalState) return null;

  var isExcluded = function isExcluded(term) {
    return !excludeTerms.includes(term.value);
  };

  var isLanguageChosen = function isLanguageChosen(lang) {
    return contentLanguages.includes(lang);
  };

  var toggleLanguage = function toggleLanguage(lang) {
    if (isLanguageChosen(lang) && contentLanguages.length === 1) {
      //do nothing
    } else {
      setContentLanguages(xor_default()(contentLanguages, [lang]));
    }
  };

  var toggleBeginnerFilter = function toggleBeginnerFilter() {
    if ((videoLevels === null || videoLevels === void 0 ? void 0 : videoLevels.length) > 0) {
      setVideoLevels([]);
    } else {
      setVideoLevels(['beginner']);
    }
  };

  var toggleTerm = function toggleTerm(term) {
    setExcludeTerms(xor_default()(excludeTerms, [term.value]));
  };

  var handleClose = function handleClose() {
    (0,apollo/* videoSettingsModalOpenVar */.cB)(false);
  };

  var handleSave = function handleSave() {
    props.handleSave({ excludeTerms: excludeTerms, contentLanguages: contentLanguages, videoLevels: videoLevels });
    handleClose();
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(base/* Modal */.u_, { open: open, handleClose: handleClose, customWidth: "650px", children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: handleClose, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(H4EXT, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "settings_modal.title", message: 'Settings' }) }) }), /*#__PURE__*/


      (0,jsx_runtime.jsxs)(base/* Body */.uT, { pt: 20, px: [25, 25, 50], pb: 30, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Label/* default */.Z, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
              id: "settings_modal.left_section_title",
              message: 'Languages' }) }) }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { mb: "10px", flexWrap: "wrap", children:
          LANGUAGES().map(function (lang) {return /*#__PURE__*/(
              (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mr: "20px", children: /*#__PURE__*/
                (0,jsx_runtime.jsxs)(Checkbox/* default */.Z, {
                  isChecked: isLanguageChosen(lang.slug),
                  onChange: function onChange() {
                    toggleLanguage(lang.slug);
                  }, children: [/*#__PURE__*/

                  (0,jsx_runtime.jsx)(Img, { src: "/static/flags/".concat(lang.icon, "@2x.png") }), " ".concat(
                  lang.label)] }) }, lang.slug));}) }), /*#__PURE__*/




        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { as: Divider/* default */.Z, mb: "20px" }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Label/* default */.Z, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
              id: "settings_modal.right_section_title",
              message: 'Sökfilter' }) }) }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
            onChange: function onChange() {return toggleBeginnerFilter();},
            isChecked: (videoLevels === null || videoLevels === void 0 ? void 0 : videoLevels.length) > 0, children: /*#__PURE__*/

            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
              id: "settings_modal.beginner",
              message: 'Beginner friendly videos' }) }) }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { as: Divider/* default */.Z, mb: "20px" }), /*#__PURE__*/
        (0,jsx_runtime.jsxs)(layout_Grid/* Box */.xu, { mb: "20px", children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "10px", children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(Label/* default */.Z, { children: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
                id: "settings_modal.helper_label",
                message: 'Customize your Yogobe experience' }) }) }), /*#__PURE__*/



          (0,jsx_runtime.jsx)(Paragraph.P, { children: /*#__PURE__*/
            (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
              id: "settings_modal.helper",
              message:
              'Get more relevant results by selecting what is included in your search results.' }) })] }), /*#__PURE__*/




        (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { flexWrap: "wrap", mx: ['0px', '0px', '-50px'], children:
          TERMS().map(function (term, index) {return /*#__PURE__*/(
              (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { width: [1, 1, 1 / 2], px: ['0px', '0px', '50px'], children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(SwitchLabel/* default */.Z, {
                  label: term.display_name,
                  value: isExcluded(term),
                  onChange: function onChange() {
                    toggleTerm(term);
                  } }) }, index));}) })] }), /*#__PURE__*/





      (0,jsx_runtime.jsxs)(base/* Footer */.$_, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "link", onClick: handleClose, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "settings_modal.secondary_button", message: 'AVBRYT' }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(buttons/* default */.ZP, { loading: props.loading, onClick: handleSave, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "settings_modal.primary_button", message: 'SKAPA' }) })] })] }));




};

/* harmony default export */ var modals_SettingsModal = (SettingsModal);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
;// CONCATENATED MODULE: ./ecosystems/VideoSettings.tsx
var VideoSettings_templateObject;










var PATCH_USER = (0,lib/* default */.ZP)(VideoSettings_templateObject || (VideoSettings_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  mutation patchUser(\n    $contentLanguages: [String]\n    $excludeTerms: [String]\n    $videoLevels: [String]\n  ) {\n    patchUser(\n      contentLanguages: $contentLanguages\n      excludeTerms: $excludeTerms\n      videoLevels: $videoLevels\n    ) {\n      user {\n        id\n      }\n    }\n  }\n"])));

















var Button = styled_components_browser_esm["default"].button.withConfig({ displayName: "VideoSettings__Button", componentId: "sc-hnjp4r-0" })(["flex-shrink:0;font-size:13px;color:", ";font-weight:600;border:none;background:none;cursor:pointer;"],


function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.black;});






var VideoSettings = function VideoSettings() {
  var _useContext = (0,react.useContext)(
  UserProvider/* UserContext */.S),currentUser = _useContext[0],loadingUserPreferences = _useContext[1].loading;

  var _useQuery = (0,useQuery/* useQuery */.a)(
  apollo/* GET_VIDEO_SETTINGS */.ji),videoSettingsData = _useQuery.data,loadingVideoSettings = _useQuery.loading;

  var _useMutation = (0,useMutation/* useMutation */.D)(PATCH_USER),_useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 2),patchUser = _useMutation2[0],patchingUser = _useMutation2[1].loading;

  react.useEffect(function () {
    // when preferences are loaded
    if (currentUser !== null && currentUser !== void 0 && currentUser.preferences) {var _currentUser$preferen, _contentLanguages;
      var contentLanguages = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$preferen = currentUser.preferences) === null || _currentUser$preferen === void 0 ? void 0 : _currentUser$preferen.contentLanguages;
      if (!((_contentLanguages = contentLanguages) !== null && _contentLanguages !== void 0 && _contentLanguages.length)) {
        contentLanguages = ['en', 'se', 'fi', 'no'];
      }
      var _currentUser$preferen2 = currentUser.preferences,excludeTerms = _currentUser$preferen2.excludeTerms,videoLevels = _currentUser$preferen2.videoLevels;
      (0,apollo/* videoSettingsVar */.FY)({
        excludeTerms: excludeTerms,
        videoLevels: videoLevels,
        contentLanguages: contentLanguages });

    }
  }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.preferences]);

  var openSettingModal = function openSettingModal() {
    (0,apollo/* videoSettingsModalOpenVar */.cB)(true);
  };

  if (loadingUserPreferences || loadingVideoSettings) return null;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(Button, {
        onClick: function onClick() {
          openSettingModal();
        }, children: /*#__PURE__*/

        (0,jsx_runtime.jsx)(TextWithIcon/* default */.Z, { icon: "ygb-icon-settings", iconSize: '15px', children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
            id: "videos_genres.settings_button",
            message: 'Mina inställningar' }) }) }), /*#__PURE__*/





      (0,jsx_runtime.jsx)(modals_SettingsModal, {
        videoSettings: videoSettingsData.videoSettings,
        handleSave: /*#__PURE__*/function () {var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(variables) {return regenerator_default().wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                    // update reactive var -> reload taxonomies
                    (0,apollo/* videoSettingsVar */.FY)(variables);
                    if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
                      // update user preferences...
                      patchUser({
                        variables: variables });

                    }
                    // close modal
                    (0,apollo/* videoSettingsModalOpenVar */.cB)(false);case 3:case "end":return _context.stop();}}}, _callee);}));return function (_x) {return _ref2.apply(this, arguments);};}(),

        loading: patchingUser })] }));



};

/* harmony default export */ var ecosystems_VideoSettings = (VideoSettings);
;// CONCATENATED MODULE: ./organisms/VideoSettingsBanner.tsx





var VideoSettingsBanner_Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "VideoSettingsBanner__Wrapper", componentId: "sc-9klj1t-0" })(["display:flex;justify-content:space-between;align-items:center;padding:20px;flex:1;border-radius:4px;background-color:#e5f4fe;@media (max-width:", "){flex-direction:column;}"],










function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var VideoSettingsBanner_Text = styled_components_browser_esm["default"].p.withConfig({ displayName: "VideoSettingsBanner__Text", componentId: "sc-9klj1t-1" })(["margin:0;font-size:14px;color:#3c3c3c;@media (min-width:", "){margin-right:20px;}@media (max-width:", "){margin-bottom:20px;}"],



function (props) {return "".concat(props.theme.viewports.tablet + 1, "px");},


function (props) {return "".concat(props.theme.viewports.tablet, "px");});




var VideoSettingsBanner = function VideoSettingsBanner() {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(VideoSettingsBanner_Wrapper, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(VideoSettingsBanner_Text, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(components_Icon/* default */.Z, {
          name: "ygb-icon-infob",
          fontSize: "14px",
          color: '#96a0a4',
          mr: '10px' }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
          id: "video_settings_banner.info",
          message:
          'Customize your Yogobe experience by changing the video settings. This feature helps you narrow down your possible results.' })] }), /*#__PURE__*/



      (0,jsx_runtime.jsx)(ecosystems_VideoSettings, {})] }));


};

/* harmony default export */ var organisms_VideoSettingsBanner = (VideoSettingsBanner);
// EXTERNAL MODULE: ./skeletons/BaseSkeleton.tsx
var BaseSkeleton = __webpack_require__(30794);
;// CONCATENATED MODULE: ./skeletons/VideosGenresTaxonomiesSkeleton.js




var VideosGenresTaxonomiesSkeleton = function VideosGenresTaxonomiesSkeleton() {return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(react.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { as: layout_Grid/* ShowInMediumDown */.EO, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "20px", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(BaseSkeleton/* default */.Z, { shape: "square", height: 20, width: 100 }) }) }), /*#__PURE__*/


      (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { as: layout_Grid/* ShowInLargeUp */.tf, children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(layout_Grid/* Flex */.kC, { mb: "20px", justifyContent: "space-between", alignItems: "center", children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(BaseSkeleton/* default */.Z, { shape: "square", height: 20, width: 35 }), /*#__PURE__*/
          (0,jsx_runtime.jsx)(BaseSkeleton/* default */.Z, { shape: "square", height: 20, width: 10 })] }) })] }));};





/* harmony default export */ var skeletons_VideosGenresTaxonomiesSkeleton = (VideosGenresTaxonomiesSkeleton);
;// CONCATENATED MODULE: ./pages/[lang]/videos/genres/[genre].tsx
function _genre_ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _genre_objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? _genre_ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _genre_ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




















var TAXONOMY_SLUGS = [
'durations',
'needs',
'styles',
'instructors',
'flavors',
'bodyparts'];


function sortTaxonomies(taxonomies) {
  return (0,toConsumableArray/* default */.Z)(taxonomies || []).
  map(function (_item) {
    var item = _genre_objectSpread({}, _item);
    item.terms = (0,toConsumableArray/* default */.Z)(item.terms).sort(function (term1, term2) {
      var a = term1.name,
      b = term2.name;

      if (item.slug === 'durations') {
        // parseInt() will extract the number at the start of the string
        a = parseInt(a);
        b = parseInt(b);
      }
      return a > b ? 1 : -1;
    });
    return _genre_objectSpread({}, item);
  }).
  sort(function (a, b) {
    return TAXONOMY_SLUGS.indexOf(a.slug) - TAXONOMY_SLUGS.indexOf(b.slug);
  });
}

var _genre_Wrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "genre__Wrapper", componentId: "sc-6xwjtq-0" })(["height:100px;display:flex;flex-direction:column;align-items:center;justify-content:center;border-radius:3px;background-color:", ";transition:opacity 300ms ease-in-out;cursor:pointer;&:hover{opacity:0.8;}"],






function (_ref) {var theme = _ref.theme,channel = _ref.channel;return theme.colors.channels[channel];});








var Title = styled_components_browser_esm["default"].h3.withConfig({ displayName: "genre__Title", componentId: "sc-6xwjtq-1" })(["font-size:16px;font-weight:600;color:", ";margin:5px;text-transform:capitalize;"],


function (props) {return props.theme.colors.neutrals.white;});




var VideosCount = styled_components_browser_esm["default"].p.withConfig({ displayName: "genre__VideosCount", componentId: "sc-6xwjtq-2" })(["font-size:13px;font-weight:normal;color:", ";margin:5px;text-transform:lowercase;"],


function (props) {return props.theme.colors.neutrals.white;});




var TeacherAvatar = styled_components_browser_esm["default"].img.withConfig({ displayName: "genre__TeacherAvatar", componentId: "sc-6xwjtq-3" })(["height:40px;width:40px;border-radius:50%;margin-right:10px;"]);






var TeacherTitleWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "genre__TeacherTitleWrapper", componentId: "sc-6xwjtq-4" })(["margin-bottom:10px;display:flex;flex-direction:row;align-items:center;"]);






var TeacherTitle = styled_components_browser_esm["default"].h2.withConfig({ displayName: "genre__TeacherTitle", componentId: "sc-6xwjtq-5" })(["margin:0;font-weight:normal;::first-letter{text-transform:capitalize;}font-size:13px;strong{font-weight:600;text-transform:capitalize;}"]);












var TeacherChannel = function TeacherChannel(props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(_genre_Wrapper, { onClick: function onClick() {return props.onClick(props.slug);}, channel: props.slug, children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(Title, { children: props.channel }), /*#__PURE__*/
      (0,jsx_runtime.jsxs)(VideosCount, { children: [
        props.count, " ", /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: 'videosGenres.sessions' })] })] }));};




var TeacherSectionWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "genre__TeacherSectionWrapper", componentId: "sc-6xwjtq-6" })(["margin-top:25px;border-top:solid ", " 1px;padding-top:20px;"],

function (props) {return props.theme.colors.secondary['gray-4'];});



var TeacherSection = function TeacherSection(props) {
  var _useInstructorByGenre = (0,generated/* useInstructorByGenreQuery */.dAt)({
    variables: {
      languages: null,
      genre: props.genre,
      instructor: props.instructor || '' } }),loading = _useInstructorByGenre.loading,data = _useInstructorByGenre.data;



  if (!props.instructor || props.genre === 'all' || loading) return null;

  var _data$instructorByGen = data.instructorByGenre,instructor = _data$instructorByGen.instructor,videosCountInGenres = _data$instructorByGen.videosCountInGenres;

  if ((videosCountInGenres === null || videosCountInGenres === void 0 ? void 0 : videosCountInGenres.length) < 1) return null;
  var name = instructor.name;

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(TeacherSectionWrapper, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(TeacherTitleWrapper, { children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(TeacherAvatar, { src: instructor.assets.squareImage }), /*#__PURE__*/
        (0,jsx_runtime.jsx)(TeacherTitle, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, {
            id: 'videosGenres.discover',
            values: { name: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", { children: name }) } }) })] }), /*#__PURE__*/



      (0,jsx_runtime.jsx)(Grid/* default */.Z, { iterableItems: videosCountInGenres.filter(function (x) {return x.count;}), col: 4, children:
        function children(_ref2) {var channel = _ref2.channel,count = _ref2.count,slug = _ref2.slug;return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(TeacherChannel, {

              channel: channel,
              slug: slug,
              onClick: props.onClick,
              count: count }, channel));} })] }));





};

var getSelectedTermsFromQuery = function getSelectedTermsFromQuery(q) {
  var newSelectedTerms = {};
  Object.entries(q).forEach(function (entry) {
    if (TAXONOMY_SLUGS.includes(entry[0]) && entry[1]) {var _entry$, _entry$$split;
      newSelectedTerms[entry[0]] = (_entry$ = entry[1]) === null || _entry$ === void 0 ? void 0 : (_entry$$split = _entry$.split) === null || _entry$$split === void 0 ? void 0 : _entry$$split.call(_entry$, ',');
    }
  });
  return newSelectedTerms;
};

var Qquery = function Qquery(q) {
  if (q) {
    return "?q=".concat(encodeURIComponent(q));
  }
  return '';
};

var taxesToQuery = function taxesToQuery(prefix, newSelectedTerms) {
  var newQuery = '';
  Object.keys(newSelectedTerms).forEach(function (taxonomy, index) {
    var terms = newSelectedTerms[taxonomy] || [];
    newQuery += "".concat(taxonomy, "=").concat(terms.join(','));
    if (index + 1 !== Object.keys(newSelectedTerms).length) {
      newQuery += '&';
    }
  });

  if (newQuery.length === 0) {
    return '';
  }

  return "".concat(prefix).concat(newQuery);
};

var VideoGenres = function VideoGenres(props) {
  var router = (0,next_router.useRouter)();
  var query = router.query;
  var _useState = (0,react.useState)(query.genre || ''),genre = _useState[0],setGenre = _useState[1];
  var _useState2 = (0,react.useState)(query.q || ''),queryState = _useState2[0],setQuery = _useState2[1];
  var _useState3 = (0,react.useState)([]),taxonomies = _useState3[0],setTaxonomies = _useState3[1];
  var initialSelectedTerms = getSelectedTermsFromQuery(query);
  var _useState4 = (0,react.useState)(initialSelectedTerms),selectedTerms = _useState4[0],setSelectedTerms = _useState4[1];
  var debouncedSearchTerm = useDebounce(queryState, 500);
  var lang = query.lang;

  var _useQuery = (0,useQuery/* useQuery */.a)(
  apollo/* GET_VIDEO_SETTINGS */.ji),loadingVideoSettings = _useQuery.loading,videoSettingsData = _useQuery.data;


  var _useTaxonomiesLazyQue =







  (0,generated/* useTaxonomiesLazyQuery */.LZ)(),_useTaxonomiesLazyQue2 = (0,slicedToArray/* default */.Z)(_useTaxonomiesLazyQue, 2),getTaxonomies = _useTaxonomiesLazyQue2[0],_useTaxonomiesLazyQue3 = _useTaxonomiesLazyQue2[1],called = _useTaxonomiesLazyQue3.called,loadingTaxonomies = _useTaxonomiesLazyQue3.loading,taxonomiesData = _useTaxonomiesLazyQue3.data,refetchTaxonomies = _useTaxonomiesLazyQue3.refetch;

  (0,react.useEffect)(function () {
    var genre = query.genre;
    if (videoSettingsData !== null && videoSettingsData !== void 0 && videoSettingsData.videoSettings) {
      if (!called) {
        getTaxonomies({
          variables: {
            genre: genre === 'all' ? '' : genre,
            languages: videoSettingsData === null || videoSettingsData === void 0 ? void 0 : videoSettingsData.videoSettings.contentLanguages } });


      } else {
        refetchTaxonomies({
          genre: genre === 'all' ? '' : genre,
          languages: videoSettingsData === null || videoSettingsData === void 0 ? void 0 : videoSettingsData.videoSettings.contentLanguages });

      }
    }
  }, [videoSettingsData, query.genre]);

  (0,react.useEffect)(function () {
    if (taxonomiesData !== null && taxonomiesData !== void 0 && taxonomiesData.taxonomies && !loadingTaxonomies) {
      setTaxonomies(sortTaxonomies(taxonomiesData === null || taxonomiesData === void 0 ? void 0 : taxonomiesData.taxonomies));
    }
  }, [taxonomiesData === null || taxonomiesData === void 0 ? void 0 : taxonomiesData.taxonomies, loadingTaxonomies]);

  (0,react.useEffect)(function () {
    var QueryQ = query.q || '';
    var queryGenre = query.genre || '';
    if (
    debouncedSearchTerm !== QueryQ ||
    genre !== queryGenre ||
    !(0,lodash.isEqual)(selectedTerms, getSelectedTermsFromQuery(router.query)))
    {
      var search = Qquery(debouncedSearchTerm);
      var queryString = "".concat(search).concat(taxesToQuery(
      search ? '&' : '?',
      selectedTerms));

      router_default().replace("/[lang]/videos/genres/[genre]".concat(
      queryString), "/".concat(
      lang, "/videos/genres/").concat(genre).concat(queryString),
      { shallow: true });

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, genre, selectedTerms]);

  (0,use_deep_compare_effect_esm/* default */.ZP)(function () {
    if (query.genre !== genre) {
      setGenre(query.genre);
      setSelectedTerms([]);
    } else if (
    !(0,lodash.isEqual)(selectedTerms, getSelectedTermsFromQuery(router.query)))
    {
      setSelectedTerms(getSelectedTermsFromQuery(router.query));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  var handleInputChangeSearchBar = function handleInputChangeSearchBar(newValue) {
    setQuery(newValue);
  };

  var clearAll = function clearAll() {
    setSelectedTerms([]);
  };

  var getInstructorFromTaxonomies = function getInstructorFromTaxonomies() {var _props$pageProps;
    var instructorSlug;
    Object.keys(((_props$pageProps = props.pageProps) === null || _props$pageProps === void 0 ? void 0 : _props$pageProps.selectedTerms) || []).forEach(function (tax) {var _props$pageProps2, _props$pageProps3;
      if (tax === 'instructors' && (_props$pageProps2 = props.pageProps) !== null && _props$pageProps2 !== void 0 && _props$pageProps2.selectedTerms[tax])
      instructorSlug = (_props$pageProps3 = props.pageProps) === null || _props$pageProps3 === void 0 ? void 0 : _props$pageProps3.selectedTerms[tax][0];
    });
    return instructorSlug;
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(layout_Grid/* Container */.W2, {
      flexDirection: "column",
      mt: [25, 30, 20],
      px: [15, 20, 20],
      mb: [25, 30, 20], children: [/*#__PURE__*/

      (0,jsx_runtime.jsx)(MetaTags/* default */.Z, { title: /*i18n*/esm/* i18n._ */.ag._("opengraph.videos_genres_title") }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { mb: "20px", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Search, {
          id: "search_bar",
          onInputChange: handleInputChangeSearchBar,
          defaultInputValue: queryState }) }), /*#__PURE__*/



      (0,jsx_runtime.jsx)(layout_Grid/* Flex */.kC, { justifyContent: "space-between", alignItems: "center", mb: "20px", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(organisms_VideoSettingsBanner, {}) }),



      loadingVideoSettings || !called || loadingTaxonomies ? /*#__PURE__*/
      (0,jsx_runtime.jsx)(skeletons_VideosGenresTaxonomiesSkeleton, {}) : /*#__PURE__*/

      (0,jsx_runtime.jsx)(VideosGenresFilters, {

        taxonomies: taxonomies,
        selectedTerms: selectedTerms,
        onChange: setSelectedTerms }, genre), /*#__PURE__*/




      (0,jsx_runtime.jsx)(layout_Grid/* Box */.xu, { as: Divider/* default */.Z, mb: 20 }), /*#__PURE__*/
      (0,jsx_runtime.jsx)(ecosystems_VideoGenresList, {
        taxonomies: taxonomies,
        query: debouncedSearchTerm,
        genre: genre,
        selectedTerms: selectedTerms,
        clearAll: clearAll,
        renderTeachersSection: function renderTeachersSection() {return /*#__PURE__*/(
            (0,jsx_runtime.jsx)(TeacherSection, {
              instructor: getInstructorFromTaxonomies(),
              onClick: setGenre,
              genre: genre }));} })] }));





};var __N_SSP = true;





















/* harmony default export */ var _genre_ = (VideoGenres);

/***/ }),

/***/ 5821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/videos/genres/[genre]",
      function () {
        return __webpack_require__(53739);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4568,4872,5675,727,4334,4924,6706,4263,6066,6660,9382,8018,5551,226,8965,9774,2888,179], function() { return __webpack_exec__(5821); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);